import { router } from '@/router'
import Router, { RawLocation, Route } from 'vue-router'

enum RouterUtilsErrors {
    NAVIGATION_DUPLICATED = 'NavigationDuplicated'
}

export class RouterUtils {
    static originalPush = Router.prototype.push
    // Alternative method to ignore all navigation errors https://github.com/vuejs/vue-router/issues/2881#issuecomment-520554378
    static push(location: RawLocation): Promise<Route> {
        return new Promise((resolve, reject) => {
            RouterUtils.originalPush.call(this, location, () => {
                // on complete
                resolve(router.currentRoute)
            }, (error) => {
                // on abort

                // only ignore NavigationDuplicated error
                if (error.name === RouterUtilsErrors.NAVIGATION_DUPLICATED) {
                    resolve(router.currentRoute)
                } else {
                    reject(error)
                }
            })
        })
    }
}
